export default "__VITE_ASSET__CMhFccJA__"